export const LOCATION_SECTION_ID_GUIDES_CAROUSEL = 'guides-carousel';
export const LOCATION_SECTION_ID_LOCATION_FAQ = 'location-faq';
export const LOCATION_SECTION_ID_REVIEWS = 'reviews';
export const LOCATION_SECTION_ID_SEO_LINKS = 'seo-links';
export const LOCATION_SECTION_ID_TOP_AREAS = 'top-areas';
export const LOCATION_SECTION_ID_TOP_MODULES = 'top-modules';
export const LOCATION_SECTION_ID_TOP_TRAILS = 'top-trails';
export const LOCATION_SECTION_ID_VISITOR_INFO = 'visitor-info';
